import { call, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import {
  SET_VEHICLE_PICKED_UP_DATE,
  SET_VEHICLE_PICKED_UP_DATE_SUCCESS,
  SET_VEHICLE_PICKED_UP_DATE_FAIL
} from '../redux/OffersDetails';

function* SetVehiclePickedDateFlow({ payload: { hashId, promise: { resolve, }, }, }) {
  try {
    const endpoint = `${apiRoot}/invoices?hash_id=${hashId}`;
    const params = {
      invoice: {
        picked_up: moment().format('YYYY-MM-DD'),
      },
    };
    const response = yield call(apiCall, { method: 'POST', endpoint, params, });
    yield put(SET_VEHICLE_PICKED_UP_DATE_SUCCESS({ pick_up_date: response.picked_up, }));
    resolve();
  } catch (error) {
    yield put(SET_VEHICLE_PICKED_UP_DATE_FAIL(error));
  }
}

export default function* SetVehiclePickedDate() {
  yield takeLatest(SET_VEHICLE_PICKED_UP_DATE, SetVehiclePickedDateFlow);
}
